<template>
  <div v-if="images && images.length > 0" class="container-image">

    <div class="gallery-list-modal">
      <div class="gallery-item" v-for="(image,key) in images">
        <figure class="m-0">
          <picture>
            <PartsImageSourceList :image="image" :sizes="[500,900,1400,1920]"/>

            <img :src="image.getTyrionSrc('cachew')" :alt="image.title"
                 class="img-cover" loading="lazy" @click="showGallery(key)">
          </picture>
          <figcaption>
            {{ image.title }}
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
  <template v-else>
    <div class="alert alert-info">
      No image
    </div>
  </template>
</template>

<script setup lang="ts">
import Image from "../../../../../lib/models/Image";
import {TyrionResourceImageType} from "../../../../../lib/enums/TyrionResourceImageType";


const props = defineProps({
  images: Array<Image>
});

const emit = defineEmits(['openGallery']);

const showGallery = (position) => {
  emit('openGallery', position, props.images);
}


</script>
